<div [ngClass]="{ isLoading: isLoading }" class="feature-tag">
  <p class="feature-tag_name">{{ tagName }}</p>
  <stxt-svg-icon class="feature-tag_icon" [iconConfig]="sendIcon"></stxt-svg-icon>
</div>
